import {
  ClipboardDocumentCheckIcon,
  ClockIcon,
  InboxIcon,
  TableCellsIcon,
} from "@heroicons/react/24/outline";
import { Dialog } from "@/components/ui/Dialog";
import { MP_DIALOG_Z_INDEX_CLASS } from "./layoutConstants";

export interface PlanningSettingsDialogProps {
  open: boolean;
  onClose: () => void;
  onHistory: () => void;
  canEdit: boolean;
  onManageRows: () => void;
  canApproveMonteurProposals: boolean;
  monteurProposalsCount: number;
  onMonteurProposals: () => void;
  canApproveFeinplanungRequests: boolean;
  feinplanungRequestsCount: number;
  onFeinplanungRequests: () => void;
}

function SettingsAction({
  icon: Icon,
  label,
  badge,
  onClick,
}: {
  icon: typeof ClockIcon;
  label: string;
  badge?: number;
  onClick: () => void;
}) {
  return (
    <button type="button" className="mp-settings-action" onClick={onClick}>
      <Icon className="mp-settings-action__icon" aria-hidden />
      <span className="mp-settings-action__label">{label}</span>
      {badge != null && badge > 0 ? (
        <span className="mp-settings-action__badge">{badge}</span>
      ) : null}
    </button>
  );
}

export function PlanningSettingsDialog({
  open,
  onClose,
  onHistory,
  canEdit,
  onManageRows,
  canApproveMonteurProposals,
  monteurProposalsCount,
  onMonteurProposals,
  canApproveFeinplanungRequests,
  feinplanungRequestsCount,
  onFeinplanungRequests,
}: PlanningSettingsDialogProps) {
  const run = (action: () => void) => {
    onClose();
    action();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Planungseinstellungen"
      description="Verlauf, Zeilen und offene Anträge."
      size="md"
      zIndexClass={MP_DIALOG_Z_INDEX_CLASS}
    >
      <div className="mp-settings">
        <section className="mp-settings-section">
          <div className="mp-settings-actions">
            <SettingsAction
              icon={ClockIcon}
              label="Änderungsverlauf"
              onClick={() => run(onHistory)}
            />
            {canEdit ? (
              <SettingsAction
                icon={TableCellsIcon}
                label="Zeilen verwalten"
                onClick={() => run(onManageRows)}
              />
            ) : null}
            {canApproveMonteurProposals ? (
              <SettingsAction
                icon={InboxIcon}
                label="Terminanträge"
                badge={monteurProposalsCount}
                onClick={() => run(onMonteurProposals)}
              />
            ) : null}
            {canApproveFeinplanungRequests ? (
              <SettingsAction
                icon={ClipboardDocumentCheckIcon}
                label="Feinplanungs-Anträge"
                badge={feinplanungRequestsCount}
                onClick={() => run(onFeinplanungRequests)}
              />
            ) : null}
          </div>
        </section>
      </div>
    </Dialog>
  );
}
